import { render, staticRenderFns } from "./debugDTU.vue?vue&type=template&id=437e3f03&scoped=true"
import script from "./debugDTU.vue?vue&type=script&lang=js"
export * from "./debugDTU.vue?vue&type=script&lang=js"
import style0 from "./debugDTU.vue?vue&type=style&index=0&id=437e3f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e3f03",
  null
  
)

export default component.exports